import $ from './jquery-core.js';

import './jquery-ui.js';

export default $;
